import { bootstrapApp } from "@/config/bootstrap";

bootstrapApp().catch(error => {
  console.error("Failed to bootstrap admin application:", error);
  const root = document.getElementById("root");
  if (root) {
    root.innerHTML =
      '<div style="font-family:sans-serif;padding:2rem;text-align:center">' +
      "<h1>Configuration error</h1>" +
      "<p>Could not load application settings. Please try again later.</p>" +
      "</div>";
  }
});
